<template>
  <section class="prizes prizes--visitor">
    <div v-for="(prize) in getCarouselPrizes" :key="prize.type">
      <div class="prizes__item">
        <div class="prizes__item__wrapper">
          <div class="prizes__item__cont">
            <div class="prizes__item__cont__inner">
              <img v-if="prize.type === 'MONTHLY'" :src="getTranslations.visitor_prizes_monthly_prizes_img" alt="">
              <img v-if="prize.type === 'DAILY'" :src="getTranslations.visitor_prizes_daily_prizes_img" alt="">
              <img v-if="prize.type === 'GRAND'" :src="getTranslations.visitor_prizes_grand_prizes_img" alt="">
              <img v-if="prize.type === 'WEEKLY'" :src="getTranslations.visitor_prizes_weekly_prizes_img" alt="">
            </div>
          </div>
          <div class="prizes__item__cont">
            <div class="prizes__item__cont__inner">
              <h2 v-if="prize.type === 'MONTHLY'">{{ getTranslations.visitor_prizes_monthly_prizes }}</h2>
              <h2 v-else-if="prize.type === 'DAILY'">{{ getTranslations.visitor_prizes_daily_prizes }}</h2>
              <h2 v-else-if="prize.type === 'GRAND'">{{ getTranslations.visitor_prizes_grand_prizes }}</h2>
              <h2 v-else-if="prize.type === 'WEEKLY'">{{ getTranslations.visitor_prizes_weekly_prizes }}</h2>
              <!--<p>{{ prize.description }}</p>-->
              <!--<p>{{ prize.headline }}</p>-->
              <p>{{ prize.banner }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- ADD CLASS prizes__prize_off NEXT TO CLASS prizes__item IF THE PROJECT HAS ONLY TWO PRIZES, REMOVE CLASS prizes__prize_off IF IT HAS THREE -->
      <div v-if="getCarouselPrizes.length === 3" class="prizes__item prizes__prize_off">
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'prizes',
  data() {
    return {
      language: '',
      bgString: 'background-image: url(',
      bgEndString: ')',
    };
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getCarouselPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Prizes.vue